
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Thymic_tumor",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Thymic_tumor.vue